var _ellipse, _g, _path, _path2, _path3, _rect, _path4, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 113,
    viewBox: "0 0 163 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.02 42.9697)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8947_83111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 25H59C56.7909 25 55 26.7909 55 29V86C55 88.2091 56.7909 90 59 90H104C106.209 90 108 88.2091 108 86V71.186C108 70.2011 107.637 69.2508 106.979 68.5172L105.021 66.3301C104.363 65.5965 104 64.6462 104 63.6613V29C104 26.7909 102.209 25 100 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 25H59C56.7909 25 55 26.7909 55 29V86C55 88.2091 56.7909 90 59 90H104C106.209 90 108 88.2091 108 86V71.186C108 70.2011 107.637 69.2508 106.979 68.5172L105.021 66.3301C104.363 65.5965 104 64.6462 104 63.6613V29C104 26.7909 102.209 25 100 25Z",
    stroke: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 25H59C56.7909 25 55 26.7909 55 29V86C55 88.2091 56.7909 90 59 90H95.5C97.7091 90 99.5 88.2091 99.5 86V71.3223C99.5 70.2561 99.9256 69.2341 100.682 68.4831L102.818 66.3642C103.574 65.6132 104 64.5912 104 63.525V29C104 26.7909 102.209 25 100 25Z",
    fill: "white",
    stroke: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 24.5H90.9996V48.5V90.5H83.9996V48.5C83.9996 39.5 82.5 31.5 77.5 24.5Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0006 24.5H97.5C93 31 90.5 38.5 91 47.4999V90.4999H84V47.4999C84 37 84.0006 24.5 84.0006 24.5Z",
    fill: "#F2F2F2",
    className: "changed_1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 43.5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#C8DCFF",
    className: "changed_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47.5C90.5523 47.5 91 47.9477 91 48.5V66.5C91 67.0523 90.5523 67.5 90 67.5H85C84.4477 67.5 84 67.0523 84 66.5V48.5C84 47.9477 84.4477 47.5 85 47.5H90ZM86.5 61.5C86.2239 61.5 86 61.7239 86 62V65C86 65.2761 86.2239 65.5 86.5 65.5H88.5C88.7761 65.5 89 65.2761 89 65V62C89 61.7239 88.7761 61.5 88.5 61.5H86.5ZM86.5 49.5C86.2239 49.5 86 49.7239 86 50V53C86 53.2761 86.2239 53.5 86.5 53.5H88.5C88.7761 53.5 89 53.2761 89 53V50C89 49.7239 88.7761 49.5 88.5 49.5H86.5Z",
    fill: "#72A4FC",
    className: "changed_3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 45.5,
    width: 3,
    height: 6,
    rx: 1.5,
    fill: "#F2F2F2",
    className: "changed_4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8947_83111",
    x: 50.5,
    y: 24.5,
    width: 62,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8947_83111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8947_83111",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBg);
export default __webpack_public_path__ + "static/media/archiveBg.2fdd6cf6.svg";
export { ForwardRef as ReactComponent };